import axios from 'axios'
import { uuidv4 } from '/@/utils/uuid'
import { CURRENT_CONFIG } from './config'
import { message } from 'ant-design-vue'
import router from '/@/router'
import { ELocalStorageKey, ERouterName, EUserType } from '/@/types/enums'
import JSONbig from 'json-bigint'// 解决精度问题
import { ACCEPT_LANGUAGE_HEADER, getAcceptLanguage } from './accept-language'
export * from './type'

const REQUEST_ID = 'X-Request-Id'
function getAuthToken () {
  return localStorage.getItem(ELocalStorageKey.Token)
}

axios.defaults.transformResponse = [function (data:any) {
  if (data == null || data === '') return data
  if (typeof data !== 'string') return data
  try {
    const json = JSONbig({
      storeAsString: true,
    })
    return json.parse(data)
  } catch {
    // 补货/理货等接口成功时直接返回 success，不是 JSON
    return data
  }
}]
const instance = axios.create({
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  baseURL: CURRENT_CONFIG.baseURL,
  // timeout: 12000,
})

instance.interceptors.request.use(
  config => {
    config.headers[ELocalStorageKey.Token] = getAuthToken()
    config.headers[ACCEPT_LANGUAGE_HEADER] = getAcceptLanguage()
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

instance.interceptors.response.use(
  response => {
    const body = response.data
    // 非对象体（如直接返回 "success"）没有 code，视为成功
    if (!body || typeof body !== 'object' || Array.isArray(body)) {
      return response
    }
    if (body.code && body.code !== 0) {
      if (!response.config.silentBusinessError) {
        // 销毁所有现有消息 显示下一个提示时关闭上一个提示
        message.destroy()
        message.error(body.message)
      }
      if (body.code === 401) {
        const flag: number = Number(localStorage.getItem(ELocalStorageKey.Flag))
        switch (flag) {
          case EUserType.Web:
            router.push(ERouterName.PROJECT)
            break
          case EUserType.Pilot:
            router.push(ERouterName.PILOT)
            break
          default:
            router.push(ERouterName.PROJECT)
            break
        }
      }
      return Promise.reject(body)
    }
    return response
  },
  err => {
    const requestId = err?.config?.headers && err?.config?.headers[REQUEST_ID]
    if (requestId) {
      console.info(REQUEST_ID, '：', requestId)
    }
    console.info('url: ', err?.config?.url, `【${err?.config?.method}】 \n>>>> err: `, err)

    let description = '-'
    if (err.response?.data && err.response.data.message) {
      description = err.response.data.message
    }
    if (err.response?.data && err.response.data.result) {
      description = err.response.data.result.message
    }
    // @See: https://github.com/axios/axios/issues/383
    // 无响应（网络中断、CORS 拦截、网关 502 空包等）只提示，不跳登录页
    if (!err.response || !err.response.status) {
      if (!err.config?.silentBusinessError) {
        message.error(description !== '-' ? description : '网络异常，请稍后重试')
      }
      return Promise.reject(err)
    }
    if (err.response.status !== 200) {
      if (err.response.status === 401) {
        const flag: number = Number(localStorage.getItem(ELocalStorageKey.Flag))
        switch (flag) {
          case EUserType.Web:
            router.push(ERouterName.PROJECT)
            break
          case EUserType.Pilot:
            router.push(ERouterName.PILOT)
            break
          default:
            router.push(ERouterName.PROJECT)
            break
        }
      } else if (!err.config?.silentBusinessError) {
        message.error(`ERROR_CODE: ${err.response.status}`)
      }
    }
    return Promise.reject(err)
  },
)

export default instance
